// third-party
import { FormattedMessage } from "react-intl";

// assets

import {
  IconUserCheck,
  IconLanguage,
  IconMessageLanguage,
  IconBuildingHospital,
  IconBuildingCommunity,
  IconUsers,
  IconUserCircle,
  IconBellRinging,
  IconBuildingSkyscraper,
  IconClipboardList,
  IconDeviceAnalytics,
  IconMessages,
  IconMail,
  IconHelp,
  IconHome,
} from "@tabler/icons";
const role = localStorage.getItem("role");

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //
const other = {
  id: "sample-docs-roadmap",
  type: "group",
  role: "Admin",
  children: [
    {
      id: "Dashboard",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",

      url: "/dashboard",
      icon: IconClipboardList,
      breadcrumbs: false,
    },
    {
      id: "Analytics",
      title: <FormattedMessage id="Analytics" />,
      type: "item",
      url: "/analytics",
      icon: IconDeviceAnalytics,
      breadcrumbs: false,
    },
    {
      id: "Users",
      title: <FormattedMessage id="Users" />,
      type: "item",
      url: "/users",
      icon: IconUserCheck,
      breadcrumbs: false,
    },
    {
      id: "Property Owner",
      title: <FormattedMessage id="Property Owner" />,
      type: "item",
      url: "/property-owner",
      icon: IconUserCircle,
      breadcrumbs: false,
    },
    {
      id: "Staff",
      title: <FormattedMessage id="Staff" />,
      type: "item",
      url: "/staff",
      icon: IconUsers,
      breadcrumbs: false,
    },
    {
      id: "Properties",
      title: <FormattedMessage id="Properties" />,
      type: "item",
      url: "/properties",
      icon: IconHome,
      breadcrumbs: false,
    },
    {
      id: "Property Request",
      title: <FormattedMessage id="Property Request" />,
      type: "item",
      url: "/property-request",
      icon: IconBuildingSkyscraper,
      breadcrumbs: false,
    },
    {
      id: "Reported Properties",
      title: <FormattedMessage id="Reported Properties" />,
      type: "item",
      url: "/reported-properties",
      icon: IconBuildingCommunity,
      breadcrumbs: false,
    },
    {
      id: "Property Field",
      title: <FormattedMessage id="Property Field" />,
      type: "item",
      url: "/property-field",
      icon: IconBuildingCommunity,
      breadcrumbs: false,
    },
    {
      id: "Notification",
      title: <FormattedMessage id="Notification" />,
      type: "item",
      url: "/notification",
      icon: IconBellRinging,
      breadcrumbs: false,
      chip: {
        label: "9",
        color: "primary",
      },
    },
    {
      id: "Chat",
      title: <FormattedMessage id="Chat" />,
      type: "item",
      url: "/chat",
      icon: IconMessages,
      breadcrumbs: false,
      chip: {
        label: "3",
        color: "primary",
      },
    },
    {
      id: "Email Template",
      title: <FormattedMessage id="Email Template" />,
      type: "item",
      url: "/email-template",
      icon: IconMail,
      breadcrumbs: false,
    },
    {
      id: "Staff Support",
      title: <FormattedMessage id="Staff Support" />,
      type: "item",
      url: "/staff-support",
      icon: IconHelp,
      breadcrumbs: false,
    },
    {
      id: "Languages",
      title: <FormattedMessage id="Languages" />,
      type: "item",
      url: "/languages",
      icon: IconLanguage,
      breadcrumbs: false,
    },
    {
      id: "Labels",
      title: <FormattedMessage id="Labels" />,
      type: "item",
      url: "/labels",
      icon: IconMessageLanguage,
      breadcrumbs: false,
    },
    {
      id: "CMS",
      title: <FormattedMessage id="CMS" />,
      type: "item",
      url: "/content-management",
      icon: IconBuildingHospital,
      breadcrumbs: false,
    },
    {
      id: "Testimonials",
      title: <FormattedMessage id="Testimonials" />,
      type: "item",
      url: "/testimonials",
      icon: IconBuildingHospital,
      breadcrumbs: false,
    },
    {
      id: "Setting",
      title: <FormattedMessage id="Settings" />,
      type: "item",
      url: "/testimonials",
      icon: IconBuildingHospital,
      breadcrumbs: false,
    },
    
    // {
    //   id: "Settings",
    //   title: <FormattedMessage id="Settings" />,
    //   type: "collapse",
    //   icon: IconSettings,
    //   url: "/settings",
    //   children: [
    //     {
    //       id: "General",
    //       title: <FormattedMessage id="General" />,
    //       type: "item",
    //       url: "/settings/general",
    //       breadcrumbs: false,
    //     },
    //   ],
    // },
  ],
};

export default other;
